'use client';

import { usePathname } from 'next/navigation';
import { Header } from './Header/index';

export default function Headers() {
  const pathname = usePathname();

  switch (true) {
    case ['/list-tour-success'].includes(pathname): {
      return <Header.WithoutExitButton />;
    }
    case ['/tour/add-new', '/list-your-tour', '/list-tour-success'].includes(pathname): {
      return <Header.WithExitButton />;
    }
    case pathname.startsWith('/draft'): {
      return <Header.WithExitButton />;
    }
    case ['/', '/search', '/tours', '/about-us'].includes(pathname): {
      return <Header.WithSearch />;
    }
    case pathname.includes('/tours') && pathname.includes('/reservation'): {
      return <Header.WithBackButton />;
    }
    case pathname.startsWith('/tours/') && pathname.split('/').filter(Boolean).length === 2: {
      return <Header.Classic />;
    }
    case pathname.startsWith('/tours'): {
      return <Header.WithSearch />;
    }
    case pathname.startsWith('/reservations'): {
      return <Header.WithSearch />;
    }
    case pathname.includes('/account'): {
      return <Header.Classic className="border-b-0" />;
    }
    case pathname.startsWith('/destinations'): {
      return <Header.Classic />;
    }
    case pathname.startsWith('/experiences'): {
      return <Header.Classic />;
    }
    case pathname.startsWith('/guides'): {
      return <Header.Classic />;
    }
    default: {
      return <Header.Classic />;
    }
  }
}
